/**
 * Время суток в справочниках: часы работы точки и интервалы коэффициентов пробок.
 *
 * Это местное время эксплуатации (Asia/Tashkent, разд. 3.5 брифа), а не момент: оно
 * хранится строкой `HH:MM`, как в контракте, и в UTC не переводится — «аптека
 * открывается в 09:00» верно в любой день, а не в один конкретный.
 */

const CLOCK = /^([01]\d|2[0-3]):([0-5]\d)$/;
const MINUTES_IN_HOUR = 60;
/** Две цифры на часы и на минуты: `09:05`. */
const CLOCK_DIGITS = 2;

export function isClockTime(value: string): boolean {
  return CLOCK.test(value.trim());
}

/** Минуты от полуночи; `null` — строка не время суток. */
export function clockMinutes(value: string): number | null {
  const match = CLOCK.exec(value.trim());

  if (match === null) {
    return null;
  }

  return Number(match[1]) * MINUTES_IN_HOUR + Number(match[2]);
}

/** `9:5` из старых данных и `09:05:00` из PostgreSQL `time` — к виду поля `HH:MM`. */
export function normaliseClock(value: string | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }

  const match = /^(\d{1,2}):(\d{1,2})/.exec(value.trim());

  if (match === null) {
    return value.trim();
  }

  return `${(match[1] ?? '').padStart(CLOCK_DIGITS, '0')}:${(match[2] ?? '').padStart(CLOCK_DIGITS, '0')}`;
}
